import PageScrollSmoother from "../PageScrollSmoother";
import gsap from "gsap";

export default class SingleShowcase {
  static instance;

  constructor() {
    if (SingleShowcase.instance) {
      return SingleShowcase.instance;
    }
    SingleShowcase.instance = this;

    this.scrollSmoother = new PageScrollSmoother();

    this.fromLeft();
    this.fromRight();
    this.fromBottom();
    this.fromTop();
    this.zoomIn();
    this.zoomOut();
    this.fade();
  }

  fade() {
    const elements = gsap.utils.toArray(".fade");

    elements.forEach((ele) => {
      const tl = new gsap.timeline({
        scrollTrigger: {
          trigger: ele,
          start: "top 80%",
          end: "bottom 50%",
          scrub: true,
          markers: false,
        },
      });

      tl.fromTo(
        ele,
        {
          opacity: 0,
        },
        { opacity: 1 }
      );
    });
  }

  fromLeft() {
    const elements = gsap.utils.toArray(".from-left");

    elements.forEach((ele) => {
      const tl = new gsap.timeline({
        scrollTrigger: {
          trigger: ele,
          start: "top 80%",
          end: "bottom 50%",
          scrub: true,
          markers: false,
        },
      });

      tl.fromTo(
        ele,
        {
          opacity: 0,
          xPercent: -25,
        },
        { opacity: 1, xPercent: 0 }
      );
    });
  }

  fromRight() {
    const elements = gsap.utils.toArray(".from-right");

    elements.forEach((ele) => {
      const tl = new gsap.timeline({
        scrollTrigger: {
          trigger: ele,
          start: "top 80%",
          end: "bottom 50%",
          scrub: true,
          markers: false,
        },
      });

      tl.fromTo(
        ele,
        {
          opacity: 0,
          xPercent: 25,
        },
        { opacity: 1, xPercent: 0 }
      );
    });
  }

  fromTop() {
    const elements = gsap.utils.toArray(".from-top");

    elements.forEach((ele) => {
      const tl = new gsap.timeline({
        scrollTrigger: {
          trigger: ele,
          start: "top 80%",
          end: "bottom 50%",
          scrub: true,
          markers: false,
        },
      });

      tl.fromTo(
        ele,
        {
          opacity: 0,
          yPercent: -10,
        },
        { opacity: 1, yPercent: 0 }
      );
    });
  }

  fromBottom() {
    const elements = gsap.utils.toArray(".from-bottom");

    elements.forEach((ele) => {
      const tl = new gsap.timeline({
        scrollTrigger: {
          trigger: ele,
          start: "top 80%",
          end: "bottom 50%",
          scrub: true,
          markers: false,
        },
      });

      tl.fromTo(
        ele,
        {
          opacity: 0,
          yPercent: 10,
        },
        { opacity: 1, yPercent: 0 }
      );
    });
  }

  zoomIn() {
    const elements = gsap.utils.toArray(".zoom-in");

    elements.forEach((ele) => {
      const tl = new gsap.timeline({
        scrollTrigger: {
          trigger: ele,
          start: "top 80%",
          end: "bottom 50%",
          scrub: true,
          markers: false,
        },
      });

      tl.fromTo(
        ele.querySelector("img"),
        {
          opacity: 0,
          scale: 1.2,
        },
        { opacity: 1, scale: 1 }
      );
    });
  }

  zoomOut() {
    const elements = gsap.utils.toArray(".zoom-out");

    elements.forEach((ele) => {
      const tl = new gsap.timeline({
        scrollTrigger: {
          trigger: ele,
          start: "top 80%",
          end: "bottom 50%",
          scrub: true,
          markers: false,
        },
      });

      tl.fromTo(
        ele.querySelector("img"),
        {
          opacity: 0,
          scale: 0.8,
        },
        { opacity: 1, scale: 1 }
      );
    });
  }
}
